import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import EnquiryModal from "../../../Components/EnquiryModal";
import ScrollToTopArrow from "../../../Components/ScrollToTopArrow";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.state]);
  return (
    <div className="site-wrapper">
      <Navbar />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
      <EnquiryModal autoOpen={true} showButton={false} />
      <ScrollToTopArrow />
    </div>
  );
};

export default Layout;
